/* Imagens aguardam a rolagem; fotos alternativas aguardam o hover. */
(function () {
  'use strict';
  function load(img) {
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
    if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
    img.removeAttribute('data-imagem-pendente');
  }
  var pending = document.querySelectorAll('img[data-imagem-pendente]');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { load(entry.target); observer.unobserve(entry.target); } });
    }, { rootMargin: '240px' });
    pending.forEach(function (img) { observer.observe(img); });
  } else pending.forEach(load);
  function hover(e) {
    if (e.type === 'pointerover' && e.pointerType !== 'mouse') return;
    var card = e.target.closest('.peca'), img = card && card.querySelector('img[data-hover-src]');
    if (img) { img.src = img.dataset.hoverSrc; delete img.dataset.hoverSrc; }
  }
  document.addEventListener('pointerover', hover, { passive: true }); document.addEventListener('focusin', hover);
})();
